import gsap from "gsap";

const DURATION = 0.25;

function closePanel(panel) {
  gsap.to(panel, {
    height: 0,
    opacity: 0,
    duration: DURATION,
    ease: "power2.inOut",
    onComplete: () => gsap.set(panel, { display: "none" }),
  });
}

function openPanel(panel) {
  panel.style.display = "block";
  panel.style.overflow = "hidden";
  panel.style.opacity = "0";
  const fullHeight = panel.scrollHeight;
  panel.style.height = "0px";
  gsap.to(panel, { height: fullHeight, opacity: 1, duration: DURATION, ease: "power2.inOut" });
}

export default function Faq() {
  Alpine.data("faq", () => ({
    openIndex: null,

    init() {
      this.$el.querySelectorAll("[data-faq-panel]").forEach((panel) => {
        gsap.set(panel, { display: "none", height: 0, opacity: 0, overflow: "hidden" });
      });
    },

    toggle(index) {
      const panels = this.$root.querySelectorAll("[data-faq-panel]");
      const target = panels[index];

      if (!target) return;

      if (this.openIndex === index) {
        closePanel(target);
        this.openIndex = null;
        return;
      }

      if (this.openIndex !== null) {
        const prev = panels[this.openIndex];
        if (prev) closePanel(prev);
      }

      openPanel(target);
      this.openIndex = index;
    },

    isOpen(index) {
      return this.openIndex === index;
    },
  }));
}
